import { render, staticRenderFns } from "./in-course.vue?vue&type=template&id=e5454b4a&"
import script from "./in-course.vue?vue&type=script&lang=js&"
export * from "./in-course.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports